"use strict";
var Numeral = require("numeral");
var language = {
    delimiters: {
        thousands: " ",
        decimal: ","
    },
    abbreviations: {
        thousand: "тыс.",
        million: "млн",
        billion: "b",
        trillion: "t"
    },
    ordinal: function () {
        // not ideal, but since in Russian it can taken on 
        // different forms (masculine, feminine, neuter)
        // this is all we can do
        return ".";
    },
    currency: {
        symbol: "₽"
    }
};
Numeral.language("ru", language);
Numeral.language("ru");
var StringUtils = (function () {
    function StringUtils() {
    }
    StringUtils.pluralize = function (number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    };
    StringUtils.clearFromTags = function (html) {
        var div = document.createElement("div");
        div.innerHTML = html;
        var text = div.textContent || div.innerText || "";
        return text;
    };
    StringUtils.getParam = function (name) {
        var queryString = window.location.search.replace("?", "").toLowerCase();
        var params = queryString.split("&").filter(function (p) { return p.indexOf(name) !== -1; });
        if (params.length > 0) {
            return params[0].replace(name + "=", "");
        }
        return null;
    };
    StringUtils.compareWithoutLineBreaks = function (str1, str2) {
        var lineBreakSymbols = /(\r\n|\n|\r)/gm;
        if (!str1 || !str2) {
            return false;
        }
        return str1.replace(lineBreakSymbols, " ") != str2.replace(lineBreakSymbols, " ");
    };
    return StringUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = StringUtils;
//# sourceMappingURL=stringUtils.js.map